import { ThemeProvider, CssBaseline } from "@mui/material";
import { theme } from "./theme";
import { AppRouter } from "./routes";

/**
 * Main App Component
 * Wraps the application with theme provider and router
 */
function App() {
  return (
    <ThemeProvider theme={theme}>
      <CssBaseline />
      <AppRouter />
    </ThemeProvider>
  );
}

export default App;
